import React from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { WithHint } from '../feedback/Tooltip';
import { Button } from '../input/Button';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { Stack } from '../layout/Stack';
import { Typography } from '../typography/Typography';
import { MemberCard, MemberCardSkeleton } from './MemberCard';
import { BusinessMemberUI } from './types';

interface BusinessMembersProps {
    items: BusinessMemberUI[];
    onRemove: (memberId: string) => void;
    onApprove: (memberId: string) => void;
    isLoading: boolean;
    onOpenInviteMemberDialog: () => void;
    canEditBusiness: boolean;
}

const PLACEHOLDER_COUNT = 3;

export const BusinessMembers = (props: BusinessMembersProps) => {
    const t = useTranslation();
    const { items, isLoading, onRemove, onApprove, onOpenInviteMemberDialog, canEditBusiness } =
        props;

    return (
        <Flex
            px={2}
            width="100%"
            height={{ xs: '100%', sm: 'auto' }}
            borderRadius={2}
            backgroundColor="var(--background-primary)"
        >
            <WithHint
                message={
                    'Для добавления нового администратора необходимо отправить ссылку и подтвердить после перехода на странице настроек.\n\n Добавленные администраторы обладают равными правами.'
                }
            >
                <Typography variant="title3" weight="bold" py={2}>
                    {t('Администраторы профиля')}
                </Typography>
            </WithHint>
            <Stack
                count={isLoading ? PLACEHOLDER_COUNT : items.length}
                renderItem={(index) => {
                    const member = items[index];

                    if (!member) {
                        return <MemberCardSkeleton key={index} />;
                    }

                    return (
                        <MemberCard
                            key={index}
                            member={member}
                            onRemove={onRemove}
                            onApprove={onApprove}
                        />
                    );
                }}
                width="100%"
            />
            <Box width="100%" py={2}>
                <Button
                    width="100%"
                    type="button"
                    variant="outlined"
                    disabled={!canEditBusiness}
                    onClick={onOpenInviteMemberDialog}
                >
                    {t('Создать приглашение')}
                </Button>
            </Box>
        </Flex>
    );
};
